import { apiService } from "../services/base-api-service";
import { endPoints, getSignSimpliOrchestrationServiceEndPoint } from "../services/api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";
class SignSimpliOrchestrationService {
  SignSimpliOrchestrationService(url) {
    return getSignSimpliOrchestrationServiceEndPoint(url);
  }
  getEnvelopDocumentByDocId(docId) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.ENVELOP_DOCUMENT_BY_DOCID.replace(":docid", docId)}`
    );
    return apiService.get(createSignSimpliEndpoint, null, getAuthHeader());
  }
  getEnvelopByEnvelopId(envelopeId) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.GET_ENVELOP_BY_ENVELOPID.replace(":envelopid", envelopeId)}`
    );
    return apiService.get(createSignSimpliEndpoint, null, getAuthHeader());
  }
  getEnvelopDocumentByEnvelopeDocId(envelopeDocId) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.UPDATE_ENVELOP_BY_ENVELOPDOCID.replace(":envelopedocid", envelopeDocId)}`
    );
    return apiService.get(createSignSimpliEndpoint, null, getAuthHeader());
  }
  updateEnvelopDocument(envelopeDocument) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.UPDATE_ENVELOP_DOCUMENT}`
    );
    return apiService.put(createSignSimpliEndpoint, envelopeDocument, getAuthHeader());
  }
  updateEnvelope(envelope) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.UPDATE_ENVELOP}`
    );
    return apiService.put(createSignSimpliEndpoint, envelope, getAuthHeader());
  }
  getEnvelopeDocument(evpId) {
    const createSignSimpliEndpoint = this.SignSimpliOrchestrationService(
      `${endPoints.signSimpliOrchServcie.GET_ENVELOP_DOCUMENT.replace(":envelopId", evpId)}`
    );
    return apiService.get(createSignSimpliEndpoint, null, getAuthHeader());
  }
}
export default new SignSimpliOrchestrationService();
